import React from 'react';
import { Outlet } from 'react-router-dom';

import Footer from '@components/Footer';
import StoneHeader from '@components/StoneHeader/StoneHeader';

export function StoneInventoryLayout() {
  return (
    <div className="min-h-screen bg-[#F8F9FA] dark:bg-dark-neutral-bg flex flex-col">
      <StoneHeader />
      <main className="flex-1 max-w-[1600px] w-full mx-auto p-6 md:p-10">
        <React.Suspense fallback={<div className="flex items-center justify-center h-full">Loading...</div>}>
          <Outlet />
        </React.Suspense>
      </main>
      <Footer />
    </div>
  );
}

export default StoneInventoryLayout;
